import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./styles/PosCashOp.module.css";

import DataContext from "../../../context/DataContext";
import useCurrencySymbol from "../../../hooks/useCurrencySymbol";
import { useTranslation } from "react-i18next";
import POSDataContext from "../../../context/POSDataContext";
import Button from "../../../components/ui/button/Button";
import AuthContext from "../../../context/AuthContext";
import { axiosSW } from "../../../api/axiosDefaults";
import { useNavigate } from "react-router-dom";
import InputNumber from "../../../components/ui/input_number/InputNumber";
import useAuthReady from "../../../hooks/useAuthReady";

// The buttons for the cash-in and cash-out operations.
// new button with methods and urls can be added later if needed
const BUTTONS = [
    {
        body: "cash-in",
        value: true,
        url: "CashierFund/pos/DepositFunds",
    },
    {
        body: "cash-out",
        value: false,
        url: "CashierFund/pos/WithdrawFunds",
    },
];

// The default form input.
// used to reset the form input when the user changes the operation type.
const DEFAULT_FORM_INPUT = {
    // method: "cash-in",
    amount: null,
    url: "CashierFund/pos/DepositFunds",
};

const PosCashOpForm = ({}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const amountRef = useRef(null);
    const {
        connection, // {Object} - The current client settings
        homePath, // {String} - The home page path
    } = useContext(DataContext);

    const {
        user, // {Object} - The cuurent authinticated user object
    } = useContext(AuthContext);
    const {
        setIsLoadingPos, // {Function} - Sets the 'isLoadingPOS' state.
        handleErrorPos, // {Function} - Handles errors in the POS system.
        userLogout,
    } = useContext(POSDataContext);
    const [buttons, setButtons] = useState(BUTTONS);
    const [formInput, setformInput] = useState(DEFAULT_FORM_INPUT);
    const [APIAdress, setAPIAdress] = useState("");
    const [hoverFlag, setHoverFlag] = useState(false);
    const [formButtonDisable, setFormButtonDisable] = useState(true);
    const currency = useCurrencySymbol(true);

    // Focus on the amount input when the component mounts.
    useEffect(() => {
        amountRef.current && amountRef.current.focus();
    }, []);

    // Set the API address based on the selected method.
    useEffect(() => {
        setAPIAdress(formInput?.url);
    }, [formInput?.url]);

    // Disable the form button if the amount is not valid.
    useEffect(() => {
        setFormButtonDisable(!(formInput?.amount && formInput?.amount > 0));
    }, [formInput]);

    /**
     * Choose the type of the operation (cash-in or cash-out) via the corresponding button.
     * clicking on the button will set the value to true for the clicked button and false for the other.
     * the url key in the formInput object will be set to the url in the dataset.ex of the clicked button.
     * @param {Integer} index - The index of the button.
     * @param {Event} event - The event object.
     */
    const handletype = (index, event) => {
        event.preventDefault();
        setformInput(DEFAULT_FORM_INPUT);
        const url = event.target.dataset.ex; // The url stored in dataset.ex of the button.
        // update the form input with the new method and url.
        setformInput((prevformInput) => ({
            ...prevformInput,
            // method: event.target.value,
            url: url,
        }));
        //focus on the amount input when the user changes the operation type.
        amountRef.current && amountRef.current.focus();
        // set the value to true for the clicked button and false for the other.
        setButtons((prevButtons) =>
            prevButtons.map((button, i) => ({
                ...button,
                value: i === index,
            })),
        );
    };
    /**
     * Change handle
     * @param {Event} event - The event object.
     */
    const handleChange = (event) => {
        setformInput((prevformInput) => ({
            ...prevformInput,
            [event.target.name]:
                event.target.type === "checkbox"
                    ? event.target.checked
                    : event.target.value,
        }));
    };

    /**
     * Submit handle
     * @param {event} event - The event object.
     */
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formButtonDisable) {
            setIsLoadingPos(true);
            const payload = {
                uniqueIdentifier: connection?.uniqueIdentifier,
                cashierSessionID: user?.cashierSessionID,
                amount: formInput?.amount,
                paymentMethod: "cash", // the default payment method for cash operations
                comment: "",
            };

            try {
                const { data } = await axiosSW.post(APIAdress, payload);

                navigate(`${homePath}/summary`);
                setIsLoadingPos(false);
            } catch (error) {
                if (error?.request?.status === 404) {
                    setIsLoadingPos(false);
                    userLogout();
                } else {
                    console.log(error);
                    setIsLoadingPos(false);
                    handleErrorPos(error);
                }
            }
        }
    };

    // /**
    //  * Go back handle Not used currently
    //  * go back 1 step in the history
    //  */
    // const handleGoBack = () => {
    //     navigate(-1);
    // };

    return (
        <aside className={`${styles.main_form_container} v-flex-container`}>
            <section className={` ${styles.stretch} v-flex-container`}>
                <form
                    className={`${styles.form_container} v-flex-container`}
                    onSubmit={handleSubmit}
                    noValidate={true} // Disable default HTML5 validation
                >
                    <div
                        className={` ${styles.cash_type_buttons_container} flex-container`}
                    >
                        {
                            // Create buttons from the buttons array.
                            buttons.map((button, idx) => (
                                <div
                                    key={idx}
                                    className={`${styles.cash_type_button_container} flex-container`}
                                >
                                    <Button
                                        body={t(button?.body)}
                                        size={"adapt"}
                                        type={"button"}
                                        fullWidth={true}
                                        active={button?.value}
                                        data={button?.url} // The url for the operation.
                                        onClickFuction={(event) =>
                                            handletype(idx, event)
                                        }
                                    />
                                </div>
                            ))
                        }
                    </div>
                    <div
                        className={`${styles.payment_number} v-flex-container`}
                    >
                        <h4>{t("cash amount")}</h4>
                        <InputNumber
                            ref={amountRef}
                            inputId={"amount"}
                            inputValue={formInput?.amount}
                            handleChangeFunction={handleChange}
                            required={hoverFlag && formButtonDisable}
                            placeholder={t("required")}
                            textAlign={"center"}
                            adaptFont={true}
                        />
                    </div>
                    <div
                        className={`${styles.form_button_container} flex-container`}
                    >
                        <div className={`${styles.button_container}`}>
                            <Button
                                body={t(`submit`)}
                                type={"submit"}
                                disabled={formButtonDisable}
                                color={"green"}
                                setHoverFlag={setHoverFlag}
                                size={"adapt"}
                                fullWidth={true}
                            />
                        </div>
                    </div>
                </form>
            </section>
        </aside>
    );
};

export default PosCashOpForm;
